/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationBaseForAlerts extends models.GovernanceConfigurationBaseForOperations {
    getFixupPrototypeFunction() { return GovernanceConfigurationBaseForAlerts.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationBaseForAlerts>): GovernanceConfigurationBaseForAlerts {
        let obj = Object.assign(new GovernanceConfigurationBaseForAlerts(), model);
        GovernanceConfigurationBaseForAlerts.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationBaseForAlerts>): GovernanceConfigurationBaseForAlerts {
        if (!model) return null;
        return GovernanceConfigurationBaseForAlerts.newInstance(<GovernanceConfigurationBaseForAlerts> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationBaseForAlerts) {
        if (!obj) return;

        models.GovernanceConfigurationBaseForAlerts.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationBaseForAlerts): boolean {
        if (models.GovernanceConfigurationBaseForOperations.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationBaseForAlerts.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Specifies whether default configuration templates from tenant|master_account should applied or not
     */
    apply_default_alerts_template: boolean;

}
